(function(){
  // === Helper: only-when-visible animation pause ===
  function pauseWhenOffscreen(selector, attr) {
    var el = document.querySelector(selector);
    if (!el || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) el.removeAttribute(attr);
        else el.setAttribute(attr, 'true');
      });
    }, { threshold: 0.05 });
    io.observe(el);
  }
  pauseWhenOffscreen('.gn-trustbar', 'data-paused');
  pauseWhenOffscreen('.gn-rev-rows', 'data-paused');
  document.querySelectorAll('.gn-cta-primary').forEach(function(el){
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) el.removeAttribute('data-paused');
        else el.setAttribute('data-paused','true');
      });
    }, { threshold: 0.05 });
    io.observe(el);
  });

  // === Scroll progress (rAF-throttled — fixes design-taste #1) ===
  var prog = document.getElementById('gnProgress');
  if (prog) {
    var ticking = false;
    function updateProg() {
      var h = document.documentElement;
      var st = h.scrollTop || document.body.scrollTop;
      var sh = (h.scrollHeight || document.body.scrollHeight) - h.clientHeight;
      prog.style.width = sh > 0 ? (st / sh * 100) + '%' : '0%';
      ticking = false;
    }
    window.addEventListener('scroll', function(){
      if (!ticking) {
        requestAnimationFrame(updateProg);
        ticking = true;
      }
    }, { passive: true });
  }

  // === Countdown timer removed in v12 — top strip is now a trust marquee ===

  // === Pause marquee when off-screen (perf) ===
  pauseWhenOffscreen('.gn-marquee', 'data-paused');

  // === Fade-up on scroll ===
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('.gn-fu').forEach(function(el){ io.observe(el); });
  } else {
    document.querySelectorAll('.gn-fu').forEach(function(el){ el.classList.add('in'); });
  }

  // === Master tick — consolidates 3 setIntervals into one (Medium fix) ===
  var liveAbove = document.getElementById('liveAboveFold');
  var liveStick = document.getElementById('liveCount');
  var liveN = 142;

  var buyers = [
    { n: 'Riya from Mumbai',     t: 'just bought 3 minutes ago' },
    { n: 'Aarav from Pune',      t: 'just bought 5 minutes ago' },
    { n: 'Priya from Bengaluru', t: 'just bought 8 minutes ago' },
    { n: 'Karan from Delhi',     t: 'just bought 12 minutes ago' },
    { n: 'Sneha from Kochi',     t: 'just bought 15 minutes ago' },
    { n: 'Vikram from Chennai',  t: 'just bought 22 minutes ago' },
    { n: 'Rahul from Jaipur',    t: 'just bought 28 minutes ago' }
  ];
  var toast = document.getElementById('buyerToast');
  var tName = document.getElementById('toastName');
  var tMsg  = document.getElementById('toastMsg');
  var bi = 0;
  function showToast() {
    var b = buyers[bi % buyers.length];
    tName.textContent = b.n;
    tMsg.textContent = b.t;
    toast.classList.add('show');
    setTimeout(function(){ toast.classList.remove('show'); }, 4200);
    bi++;
  }
  // First toast at ~5.5s; thereafter every 11s
  setTimeout(showToast, 5500);

  // Live viewer ticker — 4s cadence, 60% chance to change ±2 (occasional ±3), range 100-200
  setInterval(function(){
    if (Math.random() <= 0.40) return; // 60% chance we update
    var sign = Math.random() < 0.5 ? -1 : 1;
    var step = Math.random() < 0.18 ? 3 : 2; // ~18% chance of ±3
    liveN = Math.max(100, Math.min(200, liveN + sign * step));
    [liveAbove, liveStick].forEach(function(el){
      if (!el) return;
      el.textContent = liveN;
      // re-trigger animation
      el.classList.remove('flash');
      void el.offsetWidth; /* reflow */
      el.classList.add('flash');
    });
  }, 4000);
  setInterval(showToast, 11000);

  // === Drag scroll for Problem + Features ===
  function attachDrag(elId) {
    var el = document.getElementById(elId);
    if (!el) return;
    var down = false, sx, sl, vx = 0, lx, lt, raf;
    el.addEventListener('mousedown', function(e){
      down = true; sx = e.pageX; sl = el.scrollLeft;
      vx = 0; lx = e.pageX; lt = Date.now();
      el.classList.add('dragging');
      cancelAnimationFrame(raf);
    });
    window.addEventListener('mouseup', function(){
      if (!down) return;
      down = false;
      el.classList.remove('dragging');
      cancelAnimationFrame(raf);
      (function g(){
        if (Math.abs(vx) < 0.4) return;
        el.scrollLeft -= vx;
        vx *= 0.91;
        raf = requestAnimationFrame(g);
      })();
    });
    window.addEventListener('mousemove', function(e){
      if (!down) return;
      e.preventDefault();
      var now = Date.now(), dt = Math.max(1, now - lt);
      vx = (e.pageX - lx) / dt * 14;
      lx = e.pageX; lt = now;
      el.scrollLeft = sl - (e.pageX - sx);
    }, { passive: false });
  }
  // R4 fix: bare-ID attachDrag calls were no-ops — Shopify suffixes IDs with section.id.
  // Apply drag (Problem) and marquee+drag (Features) to all matching suffixed elements.
  document.querySelectorAll('[id^="probScroll-"]').forEach(function(el){
    var down = false, sx = 0, sl = 0, vx = 0, lx = 0, lt = 0, raf;
    el.addEventListener('mousedown', function(e){
      down = true; sx = e.pageX; sl = el.scrollLeft;
      lx = e.pageX; lt = Date.now(); vx = 0;
      el.classList.add('dragging');
    });
    window.addEventListener('mouseup', function(){
      if (!down) return;
      down = false; el.classList.remove('dragging');
      cancelAnimationFrame(raf);
      (function decay(){
        if (Math.abs(vx) < 0.4) return;
        el.scrollLeft -= vx; vx *= 0.91;
        raf = requestAnimationFrame(decay);
      })();
    });
    window.addEventListener('mousemove', function(e){
      if (!down) return;
      e.preventDefault();
      var now = Date.now(), dt = Math.max(1, now - lt);
      vx = (e.pageX - lx) / dt * 14; lx = e.pageX; lt = now;
      el.scrollLeft = sl - (e.pageX - sx);
    }, { passive: false });
  });

  // Features: continuous auto-marquee + drag-to-scrub (same pattern as Solution).
  document.querySelectorAll('[id^="featScroll-"]').forEach(function(scroll){
    var track = scroll.querySelector('.gn-feat-track');
    if (!track) return;
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!prefersReducedMotion) {
      var pauseUntil = 0;
      var scrollAccum = scroll.scrollLeft;
      var SPEED = 0.5;
      var marqueeRaf = null;
      function tick() {
        if (Date.now() >= pauseUntil && !document.hidden) {
          var max = scroll.scrollWidth - scroll.clientWidth;
          if (max > 1) {
            scrollAccum += SPEED;
            if (scrollAccum >= max - 1) { scrollAccum = 0; scroll.scrollLeft = 0; }
            else { scroll.scrollLeft = Math.round(scrollAccum); }
          }
        } else {
          scrollAccum = scroll.scrollLeft;
        }
        marqueeRaf = requestAnimationFrame(tick);
      }
      marqueeRaf = requestAnimationFrame(tick);
      // R5.2: drag handler on DESKTOP MOUSE only. On touch devices, the JS scrubbing
      // fights native iOS momentum (custom decay 0.92 is ~3x weaker than iOS native),
      // so fast flicks barely advance one card. Touch path: pause marquee, let native
      // momentum scroll do its thing, resume marquee 4s after touchend.
      var isDown = false, startX = 0, startScroll = 0, vx = 0, lastX = 0, lastT = 0, momRaf;
      var supportsTouch = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);
      function onMouseDown(e) {
        isDown = true;
        pauseUntil = Date.now() + 9999999;
        scroll.classList.add('dragging');
        startX = e.pageX; lastX = e.pageX; lastT = Date.now();
        startScroll = scroll.scrollLeft; vx = 0;
        cancelAnimationFrame(momRaf);
      }
      function onMouseMove(e) {
        if (!isDown) return;
        var now = Date.now(), dt = Math.max(1, now - lastT);
        vx = (e.pageX - lastX) / dt * 14; lastX = e.pageX; lastT = now;
        scroll.scrollLeft = startScroll - (e.pageX - startX);
      }
      function onMouseUp() {
        if (!isDown) return;
        isDown = false;
        scroll.classList.remove('dragging');
        pauseUntil = Date.now() + 4000;
        (function decay(){
          if (Math.abs(vx) < 0.4) return;
          scroll.scrollLeft -= vx; vx *= 0.92;
          momRaf = requestAnimationFrame(decay);
        })();
      }
      if (!supportsTouch) {
        scroll.addEventListener('mousedown', onMouseDown);
        window.addEventListener('mousemove', onMouseMove);
        window.addEventListener('mouseup', onMouseUp);
      } else {
        scroll.addEventListener('touchstart', function(){
          pauseUntil = Date.now() + 9999999;
          scrollAccum = scroll.scrollLeft;
        }, { passive: true });
        scroll.addEventListener('touchend', function(){
          pauseUntil = Date.now() + 4000;
          setTimeout(function(){ scrollAccum = scroll.scrollLeft; }, 200);
        }, { passive: true });
      }
    }
  });

  // R4.5: scroll-driven active-card tracking for HowItWorks + Features.
  // Same pattern as Solution: compares card centers to viewport center, toggles .is-active.
  // Native momentum scrolling stays untouched — this only reads scroll position.
  function attachActiveTracker(trackSelector, cardSelector) {
    document.querySelectorAll(trackSelector).forEach(function(track){
      var cards = Array.prototype.slice.call(track.querySelectorAll(cardSelector));
      if (!cards.length) return;
      function activeIndex() {
        var min = Infinity, idx = 0;
        var viewCenter = track.scrollLeft + track.clientWidth / 2;
        cards.forEach(function(c, i){
          var cardCenter = c.offsetLeft + c.offsetWidth / 2;
          var d = Math.abs(cardCenter - viewCenter);
          if (d < min) { min = d; idx = i; }
        });
        return idx;
      }
      function syncActive() {
        var i = activeIndex();
        cards.forEach(function(c, ci){ c.classList.toggle('is-active', ci === i); });
      }
      track.addEventListener('scroll', syncActive, { passive: true });
      // Initial state — force first card active on load
      syncActive();
      // Click any card to scroll-to-center (auto-active follows)
      cards.forEach(function(card){
        card.addEventListener('click', function(){
          var cardCenter = card.offsetLeft + card.offsetWidth / 2;
          var targetScroll = cardCenter - track.clientWidth / 2;
          track.scrollTo({ left: targetScroll, behavior: 'smooth' });
        });
      });
    });
  }
  attachActiveTracker('[id^="howTrack-"]', '.gn-how-card');
  attachActiveTracker('[id^="featScroll-"]', '.gn-feat-card');

  // === HowItWorks progress bar ===
  var howTrack = document.getElementById('howTrack');
  var howProgress = document.getElementById('howProgress');
  if (howTrack && howProgress) {
    howTrack.addEventListener('scroll', function(){
      var max = howTrack.scrollWidth - howTrack.clientWidth;
      var pct = max > 0 ? Math.min(100, Math.max(33, 33 + (howTrack.scrollLeft / max) * 67)) : 33;
      howProgress.style.width = pct + '%';
    }, { passive: true });
  }

  // === FAQ toggle ===
  document.querySelectorAll('[data-faq] .gn-faq-q').forEach(function(btn){
    btn.addEventListener('click', function(){
      var item = btn.closest('[data-faq]');
      var open = item.classList.toggle('open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  // R4.8: gn-cmp4 card scroll-trigger — adds .is-visible to fire staggered row + icon reveals
  if ('IntersectionObserver' in window) {
    var cmp4Io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (!e.isIntersecting) return;
        e.target.classList.add('is-visible');
        cmp4Io.unobserve(e.target);
      });
    }, { threshold: 0.20, rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('[data-cmp-card]').forEach(function(el){ cmp4Io.observe(el); });
  } else {
    document.querySelectorAll('[data-cmp-card]').forEach(function(el){ el.classList.add('is-visible'); });
  }

  // === Comparison animation — per-section (IDs are suffixed with section.id) ===
  if ('IntersectionObserver' in window) {
    document.querySelectorAll('[id^="cmpTable-"]').forEach(function(cmp){
      var cmpIo = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if (!e.isIntersecting) return;
          var crosses = cmp.querySelectorAll('.gn-cmp-icon-them');
          var checks  = cmp.querySelectorAll('.gn-cmp-icon-us');
          var thems   = cmp.querySelectorAll('.gn-cmp-them');
          thems.forEach(function(t){ setTimeout(function(){ t.classList.add('dimmed'); }, 200); });
          crosses.forEach(function(c, i){ setTimeout(function(){ c.classList.add('show'); }, 300 + i * 100); });
          checks.forEach(function(c, i){ setTimeout(function(){ c.classList.add('show'); }, 900 + i * 160); });
          cmpIo.unobserve(cmp);
        });
      }, { threshold: 0.2 });
      cmpIo.observe(cmp);
    });
  }

  // === Problem popout pop-in on scroll-into-view ===
  if ('IntersectionObserver' in window) {
    var popoutIo = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (!e.isIntersecting) return;
        e.target.classList.add('is-popped');
        popoutIo.unobserve(e.target);
      });
    }, { threshold: 0.35, rootMargin: '0px 0px -10% 0px' });
    document.querySelectorAll('[data-popout]').forEach(function(el){ popoutIo.observe(el); });
  } else {
    document.querySelectorAll('[data-popout]').forEach(function(el){ el.classList.add('is-popped'); });
  }

  // === Stat count-up ===
  if ('IntersectionObserver' in window) {
    var statsIo = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (!e.isIntersecting) return;
        var counter = e.target.querySelector('.gn-counter');
        if (!counter) return;
        var target = parseInt(counter.getAttribute('data-target'), 10);
        var t0 = performance.now(), dur = 1400;
        function step(t){
          var p = Math.min(1, (t - t0) / dur);
          var eased = 1 - Math.pow(1 - p, 3);
          counter.textContent = Math.floor(target * eased).toLocaleString('en-IN');
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
        statsIo.unobserve(e.target);
      });
    }, { threshold: 0.5 });
    document.querySelectorAll('.gn-stat-num .gn-counter').forEach(function(el){ statsIo.observe(el.closest('.gn-stat-num')); });
  }

  // === Sticky CTA shake — once per dwell, not infinite ===
  var stickyCta = document.getElementById('stickyCta');
  if (stickyCta && 'IntersectionObserver' in window) {
    var bumped = false;
    var actionSection = document.querySelector('.gn-action');
    if (actionSection) {
      var stickyIo = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if (e.isIntersecting && !bumped) {
            stickyCta.setAttribute('data-shake', 'true');
            bumped = true;
            setTimeout(function(){ stickyCta.removeAttribute('data-shake'); }, 500);
          }
        });
      }, { threshold: 0.2 });
      stickyIo.observe(actionSection);
    }
  }

  // === Calculator fallback — ensure rows reveal even without GSAP / on reduced-motion ===
  (function(){
    var calc = document.querySelector('.gn-calc');
    if (!calc) return;
    var rows = calc.querySelectorAll('.gn-calc-row');
    var banner = document.querySelector('.gn-calc-banner');
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function reveal() {
      rows.forEach(function(r){ r.classList.add('is-revealed'); });
      if (banner) banner.classList.add('is-popped');
    }
    if (reduced) { reveal(); return; }
    // R4.4: shorter fallback (1.8s → 0.6s). If GSAP didn't reveal by then, force it.
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if (!e.isIntersecting) return;
          setTimeout(function(){
            if (rows[0] && !rows[0].classList.contains('is-revealed')) reveal();
          }, 600);
          io.disconnect();
        });
      }, { threshold: 0.15 });
      io.observe(calc);
    } else {
      reveal();
    }
  })();

  // === Solution carousel — continuous auto-marquee + drag-to-scrub (all viewports) ===
  document.querySelectorAll('[id^="solTrack-"]').forEach(function(track){
    var sectionSuffix = track.id.replace('solTrack-', '');
    var dotsWrap = document.getElementById('solDots-' + sectionSuffix);
    var cards = Array.prototype.slice.call(track.querySelectorAll('.gn-sol-card'));
    if (!cards.length) return;
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Build dot indicators
    if (dotsWrap) {
      cards.forEach(function(_, i){
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'gn-sol-dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Show benefit ' + (i + 1) + ' of ' + cards.length);
        dot.addEventListener('click', function(){
          track.scrollTo({ left: cards[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
          pauseUntil = Date.now() + 4000;
        });
        dotsWrap.appendChild(dot);
      });
    }
    var dots = dotsWrap ? dotsWrap.querySelectorAll('.gn-sol-dot') : [];

    /* R4.3: activeIndex now compares CARD CENTERS to viewport center
       (was comparing left edges, broken under center-snap). */
    function activeIndex() {
      var min = Infinity, idx = 0;
      var viewCenter = track.scrollLeft + track.clientWidth / 2;
      cards.forEach(function(c, i){
        var cardCenter = c.offsetLeft + c.offsetWidth / 2;
        var d = Math.abs(cardCenter - viewCenter);
        if (d < min) { min = d; idx = i; }
      });
      return idx;
    }
    function syncActive() {
      var i = activeIndex();
      dots.forEach(function(d, di){ d.classList.toggle('is-active', di === i); });
      // R4.3: also toggle .is-active on the cards themselves so CSS dim/highlight kicks in
      cards.forEach(function(c, ci){ c.classList.toggle('is-active', ci === i); });
    }
    track.addEventListener('scroll', syncActive, { passive: true });
    // Initial active-state on load (otherwise everything stays dim until first scroll)
    syncActive();

    if (prefersReducedMotion) return;

    // Continuous auto-marquee — accumulates subpixel float, applies on integer crossing
    var pauseUntil = 0;
    var scrollAccum = track.scrollLeft;
    var raf = null;
    var SPEED = 0.6; // px per frame ~ 36px/sec at 60fps
    function tick() {
      if (Date.now() >= pauseUntil && !document.hidden) {
        var max = track.scrollWidth - track.clientWidth;
        if (max > 1) {
          scrollAccum += SPEED;
          if (scrollAccum >= max - 1) {
            scrollAccum = 0;
            track.scrollLeft = 0;
          } else {
            track.scrollLeft = Math.round(scrollAccum);
          }
        }
      } else {
        scrollAccum = track.scrollLeft;
      }
      raf = requestAnimationFrame(tick);
    }
    raf = requestAnimationFrame(tick);

    // R5.2: drag handler on DESKTOP MOUSE only. On touch, the JS scrubbing fights
    // native iOS momentum (custom decay 0.92 is ~3x weaker than iOS native), making
    // fast flicks feel laggy. Touch path: pause marquee on touchstart, native scroll
    // does the heavy lifting, marquee resumes 4s after touchend.
    var isDown = false, startX = 0, startScroll = 0, vx = 0, lastX = 0, lastT = 0, momRaf;
    var supportsTouch = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);
    function onMouseDown(e) {
      isDown = true;
      pauseUntil = Date.now() + 9999999;
      track.classList.add('dragging');
      startX = e.pageX; lastX = e.pageX; lastT = Date.now();
      startScroll = track.scrollLeft; vx = 0;
      cancelAnimationFrame(momRaf);
    }
    function onMouseMove(e) {
      if (!isDown) return;
      var now = Date.now(), dt = Math.max(1, now - lastT);
      vx = (e.pageX - lastX) / dt * 14; lastX = e.pageX; lastT = now;
      track.scrollLeft = startScroll - (e.pageX - startX);
    }
    function onMouseUp() {
      if (!isDown) return;
      isDown = false;
      track.classList.remove('dragging');
      pauseUntil = Date.now() + 4000;
      (function decay(){
        if (Math.abs(vx) < 0.4) return;
        track.scrollLeft -= vx; vx *= 0.92;
        momRaf = requestAnimationFrame(decay);
      })();
    }
    if (!supportsTouch) {
      track.addEventListener('mousedown', onMouseDown);
      window.addEventListener('mousemove', onMouseMove);
      window.addEventListener('mouseup', onMouseUp);
    } else {
      track.addEventListener('touchstart', function(){
        pauseUntil = Date.now() + 9999999;
        scrollAccum = track.scrollLeft;
      }, { passive: true });
      track.addEventListener('touchend', function(){
        pauseUntil = Date.now() + 4000;
        setTimeout(function(){ scrollAccum = track.scrollLeft; }, 200);
      }, { passive: true });
    }
  });

  // === Card click handler ===
  // Solution: scroll-to-center on click (auto-highlight follows via the scroll IO).
  // Problem/HowItWorks/Features: simple toggle (no auto-marquee on those tracks).
  ['.gn-sol-track', '.gn-prob-track', '.gn-how-track', '.gn-feat-track'].forEach(function(selector){
    document.querySelectorAll(selector).forEach(function(track){
      var isSolTrack = selector === '.gn-sol-track';
      track.querySelectorAll('.gn-sol-card, .gn-prob-card, .gn-how-card, .gn-feat-card').forEach(function(card){
        card.addEventListener('click', function(e){
          if (track.classList.contains('dragging')) return;
          if (isSolTrack) {
            // Scroll card to center; the scroll IO will set .is-active automatically
            var cardCenter = card.offsetLeft + card.offsetWidth / 2;
            var targetScroll = cardCenter - track.clientWidth / 2;
            track.scrollTo({ left: targetScroll, behavior: 'smooth' });
          } else {
            track.querySelectorAll('.is-active').forEach(function(c){ c.classList.remove('is-active'); });
            card.classList.add('is-active');
          }
        });
      });
    });
  });

  // === Buy-intent handler — AJAX cart + GoKwik custom checkout ===
  // Bypasses Kaching Bundles by avoiding form submission entirely.
  // Flow: clear cart -> add line items via /cart/add.js -> trigger GoKwik modal.
  //
  // Variant resolution priority (per button click):
  //   1. data-variant-ids="111,222"      (Kit combos, multi-line cart)
  //   2. data-variant-id="111"           (Hero pack option, Bundle radio, etc.)
  //   3. data-bundle-source="<group>"    (Bundle CTA reads selected radio[name=group])
  //   4. selected hero pack radio with [data-variant-id]
  //   5. fallback to #gnBuyMeta.dataset.variantId (page-level default = current product)
  function gnFallbackVariantId() {
    var meta = document.getElementById('gnBuyMeta');
    return meta && meta.dataset.variantId ? parseInt(meta.dataset.variantId, 10) : null;
  }
  function gnReadHeroPackVariant() {
    var checked = document.querySelector('input[name="heroPack"]:checked');
    if (!checked) return null;
    var v = checked.dataset.variantId;
    return v ? parseInt(v, 10) : null;
  }
  function gnResolveLineItems(btn) {
    // Returns an array of { id, quantity } objects.
    // 1. multi-line: data-variant-ids (comma-separated)
    var multi = (btn.dataset.variantIds || '').trim();
    if (multi) {
      var ids = multi.split(',').map(function(s){ return parseInt(s.trim(), 10); }).filter(Boolean);
      if (ids.length) return ids.map(function(id){ return { id: id, quantity: 1 }; });
    }
    // 2. single explicit variant on the button
    var explicit = btn.dataset.variantId ? parseInt(btn.dataset.variantId, 10) : null;
    var qty = Math.max(1, parseInt(btn.dataset.buyQty || '1', 10));
    if (explicit) return [{ id: explicit, quantity: qty }];

    // 3. Bundle CTA — read currently checked radio in named group
    var bundleSource = btn.dataset.bundleSource;
    if (bundleSource) {
      var checked = document.querySelector('input[name="' + bundleSource + '"]:checked');
      if (checked) {
        var bv = checked.dataset.variantId ? parseInt(checked.dataset.variantId, 10) : null;
        var bq = Math.max(1, parseInt(checked.dataset.qty || '1', 10));
        if (bv) return [{ id: bv, quantity: bq }];
        // Variant not specified on this radio → fall back to page default + radio's qty
        var fb = gnFallbackVariantId();
        if (fb) return [{ id: fb, quantity: bq }];
      }
    }

    // 4. Hero pack picker — selected radio's variant id (if any)
    var heroVar = gnReadHeroPackVariant();
    if (heroVar) {
      var heroQty = Math.max(1, parseInt(document.querySelector('input[name="heroPack"]:checked').dataset.qty || '1', 10));
      return [{ id: heroVar, quantity: heroQty }];
    }

    // 5. Fallback to page-level default variant
    var fbId = gnFallbackVariantId();
    if (fbId) return [{ id: fbId, quantity: qty }];
    return null;
  }
  function gnAjaxClearCart() {
    return fetch('/cart/clear.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    });
  }
  function gnAjaxAddItems(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: items })
    });
  }
  function gnGokwikCheckout(btn) {
    if (typeof window.triggerGokwikCustomCheckout === 'function') {
      try { window.triggerGokwikCustomCheckout(); return true; } catch(e) { console.error('[gn] triggerGokwikCustomCheckout failed:', e); }
    }
    if (typeof window.gokwikCheckoutClickFn === 'function') {
      try { window.gokwikCheckoutClickFn(btn); return true; } catch(e) { console.error('[gn] gokwikCheckoutClickFn failed:', e); }
    }
    if (typeof window.gokwikBuyNowClickFn === 'function') {
      try { window.gokwikBuyNowClickFn(btn); return true; } catch(e) { console.error('[gn] gokwikBuyNowClickFn failed:', e); }
    }
    return false;
  }
  function gnUpdateCartUI(itemCountDelta) {
    // Bump common cart-count selectors used in Kalles/header
    var selectors = ['.cart-count', '.t4s-cart-count', '[data-cart-count]', '.header__cart-count', '.cart-counter'];
    var bumped = false;
    selectors.forEach(function(sel){
      document.querySelectorAll(sel).forEach(function(el){
        var n = parseInt((el.textContent || '0').replace(/[^0-9]/g, ''), 10) || 0;
        el.textContent = (n + itemCountDelta);
        bumped = true;
      });
    });
    return bumped;
  }
  function gnShowCartToast(message) {
    var existing = document.getElementById('gnCartToast');
    if (existing) existing.remove();
    var t = document.createElement('div');
    t.id = 'gnCartToast';
    t.className = 'gn-cart-toast';
    t.innerHTML = '<svg aria-hidden="true" width="18" height="18"><use href="#i-check"/></svg>' +
                  '<span>' + message + '</span>' +
                  '<a href="/cart" class="gn-cart-toast-link">View cart</a>';
    document.body.appendChild(t);
    requestAnimationFrame(function(){ t.classList.add('show'); });
    setTimeout(function(){ t.classList.remove('show'); setTimeout(function(){ t.remove(); }, 400); }, 3500);
  }
  function gnBuyClick(btn) {
    var mode = (btn.getAttribute('data-buy') || '').toLowerCase(); // "cart" or "" (= checkout)
    var items = gnResolveLineItems(btn);
    if (!items || !items.length) {
      console.error('[gn] no line items resolved for buy click', btn);
      var target = document.querySelector('.gn-action');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    btn.classList.add('is-loading');

    if (mode === 'cart') {
      // Add-to-cart only: no clear, no GoKwik, just update UI
      gnAjaxAddItems(items)
        .then(function(r){ return r.json(); })
        .then(function(data){
          if (data && data.status >= 400) throw new Error(data.description || 'cart add failed');
          var totalQty = items.reduce(function(s, it){ return s + (it.quantity || 1); }, 0);
          gnUpdateCartUI(totalQty);
          gnShowCartToast('Added to cart · ' + totalQty + ' item' + (totalQty > 1 ? 's' : ''));
        })
        .catch(function(err){
          console.error('[gn] AJAX cart-add error:', err);
          gnShowCartToast('Could not add to cart. Try again.');
        })
        .finally(function(){
          btn.classList.remove('is-loading');
        });
      return;
    }

    // Default: full checkout flow (clear → add → GoKwik)
    gnAjaxClearCart()
      .then(function(){ return gnAjaxAddItems(items); })
      .then(function(r){ return r.json(); })
      .then(function(data){
        if (data && data.status >= 400) throw new Error(data.description || 'cart add failed');
        if (!gnGokwikCheckout(btn)) {
          window.location.href = '/checkout';
        }
      })
      .catch(function(err){
        console.error('[gn] AJAX buy error:', err);
        var target = document.querySelector('.gn-action');
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      })
      .finally(function(){
        btn.classList.remove('is-loading');
      });
  }
  document.querySelectorAll('[data-buy]').forEach(function(btn){
    btn.addEventListener('click', function(e){ e.preventDefault(); gnBuyClick(this); });
  });

  // === Scroll-to anchor handler (rating row → Reviews, See-it-fold → How it works, etc.) ===
  document.querySelectorAll('[data-scroll-to]').forEach(function(el){
    el.addEventListener('click', function(e){
      var target = document.querySelector(el.dataset.scrollTo);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });
  // Enable CTAs once GoKwik SDK is ready
  function gnEnableBuyCtas() {
    document.querySelectorAll('[data-buy]').forEach(function(b){
      b.disabled = false;
      b.classList.remove('disabled');
    });
  }
  window.addEventListener('gokwikLoaded', gnEnableBuyCtas);
  // CTAs are click-actionable even before SDK loads (cart.js still works)
  gnEnableBuyCtas();

  // === Hero gallery — Flickity init + tap-to-zoom lightbox ===
  (function(){
    var gallery = document.getElementById('heroGallery');
    var dialog  = document.getElementById('galleryZoom');
    if (!gallery || !dialog) return;

    var stage = document.getElementById('galleryZoomStage');
    var zImg  = document.getElementById('galleryZoomImg');
    var closeBtn = dialog.querySelector('[data-zoom-close]');

    // Wait for Flickity to load (it's deferred); poll briefly
    var tries = 0;
    var pollFlickity = setInterval(function(){
      tries++;
      if (typeof Flickity === 'undefined') {
        if (tries > 80) clearInterval(pollFlickity); // give up after 8s
        return;
      }
      clearInterval(pollFlickity);
      // Flickity auto-inits via data-flickity attribute, but ensure resize after fonts settle
      setTimeout(function(){
        try { Flickity.data(gallery)?.resize(); } catch(e){}
      }, 400);
    }, 100);

    // Tap any cell -> open zoom dialog with that cell's image
    gallery.addEventListener('click', function(e){
      var cell = e.target.closest('.gn-gallery-cell');
      if (!cell) return;
      // ignore drag-clicks (Flickity sets is-pointer-down briefly)
      if (gallery.classList.contains('is-pointer-down')) return;
      var img = cell.querySelector('img');
      if (!img) return;
      zImg.src = img.currentSrc || img.src;
      zImg.alt = img.alt || '';
      zImg.style.transform = 'translate(0,0) scale(1)';
      zoomState.scale = 1; zoomState.tx = 0; zoomState.ty = 0;
      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
    });

    closeBtn.addEventListener('click', function(){ dialog.close ? dialog.close() : dialog.removeAttribute('open'); });
    dialog.addEventListener('click', function(e){ if (e.target === dialog) (dialog.close ? dialog.close() : dialog.removeAttribute('open')); });

    // Pinch + pan + double-tap zoom in lightbox
    var zoomState = { scale: 1, tx: 0, ty: 0 };
    var lastTouch = 0;
    var pinchStart = null;
    var dragStart = null;

    function applyTransform() {
      zImg.style.transform = 'translate(' + zoomState.tx + 'px,' + zoomState.ty + 'px) scale(' + zoomState.scale + ')';
    }

    stage.addEventListener('touchstart', function(e){
      if (e.touches.length === 2) {
        pinchStart = {
          dist: Math.hypot(e.touches[0].clientX - e.touches[1].clientX, e.touches[0].clientY - e.touches[1].clientY),
          scale: zoomState.scale
        };
      } else if (e.touches.length === 1) {
        var now = Date.now();
        if (now - lastTouch < 320) {
          // double-tap — toggle zoom 1x <-> 2.4x
          zoomState.scale = zoomState.scale > 1.05 ? 1 : 2.4;
          if (zoomState.scale === 1) { zoomState.tx = 0; zoomState.ty = 0; }
          applyTransform();
        }
        lastTouch = now;
        if (zoomState.scale > 1) {
          dragStart = { x: e.touches[0].clientX - zoomState.tx, y: e.touches[0].clientY - zoomState.ty };
        }
      }
    }, { passive: true });

    stage.addEventListener('touchmove', function(e){
      if (e.touches.length === 2 && pinchStart) {
        e.preventDefault();
        var d = Math.hypot(e.touches[0].clientX - e.touches[1].clientX, e.touches[0].clientY - e.touches[1].clientY);
        zoomState.scale = Math.max(1, Math.min(4, pinchStart.scale * (d / pinchStart.dist)));
        if (zoomState.scale === 1) { zoomState.tx = 0; zoomState.ty = 0; }
        applyTransform();
      } else if (e.touches.length === 1 && zoomState.scale > 1 && dragStart) {
        e.preventDefault();
        zoomState.tx = e.touches[0].clientX - dragStart.x;
        zoomState.ty = e.touches[0].clientY - dragStart.y;
        applyTransform();
      }
    }, { passive: false });

    stage.addEventListener('touchend', function(e){
      if (e.touches.length < 2) pinchStart = null;
      if (e.touches.length === 0) dragStart = null;
    });

    // Desktop click-to-zoom toggle (1x <-> 2.2x), wheel for fine-zoom
    stage.addEventListener('click', function(){
      if (window.matchMedia('(pointer: coarse)').matches) return; // mobile uses double-tap
      zoomState.scale = zoomState.scale > 1.05 ? 1 : 2.2;
      if (zoomState.scale === 1) { zoomState.tx = 0; zoomState.ty = 0; }
      applyTransform();
    });
    stage.addEventListener('wheel', function(e){
      if (window.matchMedia('(pointer: coarse)').matches) return;
      e.preventDefault();
      zoomState.scale = Math.max(1, Math.min(4, zoomState.scale + (e.deltaY < 0 ? 0.15 : -0.15)));
      if (zoomState.scale === 1) { zoomState.tx = 0; zoomState.ty = 0; }
      applyTransform();
    }, { passive: false });
  })();

  // === Reviews — inject verified-buyer tag into each card ===
  (function(){
    document.querySelectorAll('.gn-rev-card').forEach(function(card){
      if (card.querySelector('.gn-rev-loox-tag')) return;
      var tag = document.createElement('div');
      tag.className = 'gn-rev-loox-tag';
      tag.innerHTML = '<svg aria-hidden="true"><use href="#i-shield"/></svg> Verified purchase';
      card.appendChild(tag);
    });
  })();

  // === Bundle radio swap — per-section (IDs suffixed with section.id) ===
  (function(){
    function fmt(n) { return '₹' + Number(n).toLocaleString('en-IN'); }
    document.querySelectorAll('[id^="gnBundleForm-"]').forEach(function(form){
      var sectionSuffix = form.id.replace('gnBundleForm-', '');
      var pay      = document.getElementById('bundlePay-' + sectionSuffix);
      var save     = document.getElementById('bundleSave-' + sectionSuffix);
      var ctaPrice = document.getElementById('bundleCtaPrice-' + sectionSuffix);
      function syncFrom(r) {
        var p = parseInt(r.dataset.price || '0', 10);
        var s = parseInt(r.dataset.save || '0', 10);
        if (pay) pay.textContent = fmt(p);
        if (save) save.textContent = fmt(s);
        if (ctaPrice) ctaPrice.textContent = fmt(p);
      }
      var initial = form.querySelector('input[type="radio"]:checked');
      if (initial) syncFrom(initial);
      form.querySelectorAll('input[type="radio"]').forEach(function(r){
        r.addEventListener('change', function(){ if (this.checked) syncFrom(this); });
      });
    });
  })();

  // === Hero pack picker — quantity multiplier (no bundle variants yet) ===
  // On change: total = qty × unit price; CTA stores qty so GoKwik buy-now can submit it
  (function(){
    var radios = document.querySelectorAll('input[name="heroPack"]');
    if (!radios.length) return;
    var heroPriceNow   = document.getElementById('heroPriceNow');
    var heroPriceWas   = document.getElementById('heroPriceWas');
    var heroPriceBadge = document.getElementById('heroPriceBadge');
    var heroCta        = document.getElementById('heroCtaPrimary');
    var heroCtaLabel   = heroCta && heroCta.querySelector('[data-cta-label]');
    var heroCtaPrice   = heroCta && heroCta.querySelector('[data-cta-price]');
    var stickyCta      = document.getElementById('stickyCta');
    var stickyPriceNow = document.querySelector('.gn-sticky-price-now');
    var stickyPriceWas = document.querySelector('.gn-sticky-price .was');
    var stickyPriceOff = document.querySelector('.gn-sticky-price .off');
    function fmt(n) { return '₹' + Number(n).toLocaleString('en-IN'); }
    function pctOff(unit, mrp) {
      if (!mrp || mrp <= unit) return '';
      return Math.round((1 - unit/mrp) * 100) + '% off';
    }
    radios.forEach(function(r){
      r.addEventListener('change', function(){
        if (!this.checked) return;
        var qty       = parseInt(this.dataset.qty || '1', 10);
        var unitPrice = parseInt(this.dataset.unitPrice || '0', 10);
        var unitMrp   = parseInt(this.dataset.unitMrp || '0', 10);
        var cta       = this.dataset.cta || 'Add to cart';
        var totalPrice = unitPrice * qty;
        var totalMrp   = unitMrp * qty;
        if (heroPriceNow)   heroPriceNow.textContent   = fmt(totalPrice);
        if (heroPriceWas)   heroPriceWas.textContent   = fmt(totalMrp);
        if (heroPriceBadge) heroPriceBadge.textContent = pctOff(unitPrice, unitMrp);
        if (heroCtaLabel)   heroCtaLabel.textContent   = cta;
        if (heroCtaPrice)   heroCtaPrice.textContent   = fmt(totalPrice);
        if (heroCta)        heroCta.dataset.buyQty     = qty;
        if (stickyCta)      stickyCta.dataset.buyQty   = qty;
        if (stickyPriceNow) stickyPriceNow.textContent = fmt(totalPrice);
        if (stickyPriceWas) stickyPriceWas.textContent = fmt(totalMrp);
        if (stickyPriceOff) stickyPriceOff.textContent = pctOff(unitPrice, unitMrp);
      });
    });
  })();
})();

/* === Section break === */

(function(){
  function init() {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    gsap.registerPlugin(ScrollTrigger);

    // Hero image parallax (only on first slide; Flickity handles subsequent)
    var heroImg = document.getElementById('galleryMainImg');
    if (heroImg) {
      gsap.to(heroImg, {
        yPercent: -8,
        ease: 'none',
        scrollTrigger: {
          trigger: '.gn-gallery-flick',
          start: 'top bottom',
          end: 'bottom top',
          scrub: 0.6
        }
      });
    }

    // R4.4: faster Calculator reveal — stagger 110ms→55ms, banner delay 220ms→100ms.
    // Total perceived load: ~0.6s (was ~1.4s).
    var calcRows = document.querySelectorAll('.gn-calc-row');
    var calcBanner = document.querySelector('.gn-calc-banner');
    var calcPct = document.querySelector('.gn-calc-banner-pct');
    if (calcRows.length) {
      ScrollTrigger.create({
        trigger: '.gn-calc',
        start: 'top 92%',
        once: true,
        onEnter: function(){
          calcRows.forEach(function(row, i){
            setTimeout(function(){
              row.classList.add('is-revealed');
              var price = row.querySelector('.gn-calc-row-price');
              if (price) {
                price.classList.add('flash-red');
                setTimeout(function(){ price.classList.remove('flash-red'); }, 320);
              }
            }, i * 55);
          });
          if (calcBanner) {
            setTimeout(function(){ calcBanner.classList.add('is-popped'); }, calcRows.length * 55 + 100);
          }
          if (calcPct) {
            setTimeout(function(){ calcPct.classList.add('is-pulse'); }, calcRows.length * 55 + 500);
          }
        }
      });
    }

    // Reviews summary card lift on enter
    var revSummary = document.querySelector('.gn-rev-summary');
    if (revSummary) {
      gsap.from(revSummary, {
        y: 32, opacity: 0,
        duration: 0.7, ease: 'power3.out',
        scrollTrigger: { trigger: revSummary, start: 'top 85%', toggleActions: 'play none none none' }
      });
    }

    // (Comparison row stagger handled by IntersectionObserver in body script — avoids "opacity: 0" stuck state when user jumps past trigger)
  }
  if (document.readyState === 'complete') init();
  else window.addEventListener('load', init);
})();
